module.exports = __webpack_public_path__ + "img/2.748e7504.png";